export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14713.af98d756.jpg";